// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container___PEEN","icon":"style_icon__JBtww","text":"style_text__Nl4am","close":"style_close__89NA1"};